'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _chunk = require('lodash/chunk');

var _chunk2 = _interopRequireDefault(_chunk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pagination = function (_Component) {
  _inherits(Pagination, _Component);

  function Pagination() {
    _classCallCheck(this, Pagination);

    var _this = _possibleConstructorReturn(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).apply(this, arguments));

    _this.state = {
      pageNumber: 0,
      allPages: _this.paginate(_this.props.toPaginate)
    };

    _this.paginate = _this.paginate.bind(_this);
    _this.handlePagintionClick = _this.handlePaginationClick.bind(_this);
    return _this;
  }

  _createClass(Pagination, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var toPaginate = _ref.toPaginate;

      if (this.props.persistPage) {
        this.setState({
          allPages: this.paginate(toPaginate)
        });
      } else {
        this.setState({
          pageNumber: 0,
          allPages: this.paginate(toPaginate)
        });
      }
    }
  }, {
    key: 'paginate',
    value: function paginate(toPaginate) {
      var _props$max = this.props.max,
          max = _props$max === undefined ? 10 : _props$max;

      return (0, _chunk2.default)(toPaginate, max);
    }
  }, {
    key: 'handlePaginationClick',
    value: function handlePaginationClick(val) {
      var _this2 = this;

      var _state = this.state,
          allPages = _state.allPages,
          pageNumber = _state.pageNumber;

      var canNext = pageNumber + 1 < allPages.length;
      var canPrev = pageNumber > 0;

      var changePage = function changePage() {
        return _this2.setState({
          pageNumber: pageNumber + val
        });
      };

      if (val > 0) {
        return canNext ? changePage : null;
      } else {
        return canPrev ? changePage : null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state2 = this.state,
          allPages = _state2.allPages,
          pageNumber = _state2.pageNumber;


      if (allPages.length) {
        return _react2.default.createElement(
          'div',
          null,
          this.props.children({
            allPages: allPages,
            currentPage: allPages[pageNumber],
            numberOfPages: allPages.length,
            pageIndex: this.state.pageNumber,
            pageNumber: this.state.pageNumber + 1,
            pageOf: 'Page ' + (this.state.pageNumber + 1) + ' of ' + allPages.length,
            isPaginated: allPages.length > 1,
            canNext: pageNumber + 1 < allPages.length,
            canPrev: pageNumber > 0,
            next: this.handlePaginationClick(+1),
            prev: this.handlePaginationClick(-1)
          })
        );
      } else return null;
    }
  }]);

  return Pagination;
}(_react.Component);

exports.default = Pagination;


Pagination.defaultProps = {
  max: 10
};

Pagination.propTypes = {
  /**
   * The array to be paginated
   */
  toPaginate: _propTypes2.default.array.isRequired,

  /**
   * The max amount of items per page
   */
  max: _propTypes2.default.number,

  /**
   * A render prop that gets called with the paginated data and methods to control it.
   */
  children: _propTypes2.default.func.isRequired,

  /**
   * Prevents the page number being reset when toPaginate changes
   */
  persistPage: _propTypes2.default.bool
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/pagination/index.js
// module id = 241
// module chunks = 0